import { Toast } from '@shared/components/toast';

export const REGISTER_TOASTS: Record<string, Toast> = {
  ERROR_FORMING: {
    message: 'Error forming registration data.',
    type: 'error',
  },
  SUCCESS: {
    message: 'Register successful.',
    type: 'success',
  },
  AUTO_LOGIN_SUCCESS: { message: 'Auto login successful.', type: 'success' },
  ERROR_LOGIN: {
    message: 'Access to login session failed.',
    type: 'error',
  },
  ERROR_REGISTER: {
    message: 'Register failed.',
    type: 'error',
  },
};
